import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EmployeeUploadInfo } from '../models/employee-upload-info';
import { EmployeeDto } from '../models/EmployeeDto';
import { ApiResponseObject } from '../models/responses/api-response-object';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private httpClient: HttpClient) { }

  upload(file: any): Observable<ApiResponseObject<EmployeeDto[]>> {

    return this.httpClient.post<ApiResponseObject<EmployeeDto[]>>(`${environment.apiUrl}/Employees/uploadEmployees`, file)
  }
  GetByRequest(id: number, type:string): Observable<ApiResponseObject<EmployeeUploadInfo[]>> {
    return this.httpClient.get<ApiResponseObject<EmployeeUploadInfo[]>>(`${environment.apiUrl}/EmployeeUploads/GetByRequest/${id}/${type}`);
  }
  createSingleEmployee (request: any): Observable<ApiResponseObject<any>> {
    return this.httpClient.post<ApiResponseObject<any>>(`${environment.apiUrl}/Employees/SingleEmployee`, request);
  }
  
  DeleteFile(id: number): Observable<ApiResponseObject<EmployeeUploadInfo[]>> {
    return this.httpClient.get<ApiResponseObject<EmployeeUploadInfo[]>>(`${environment.apiUrl}/EmployeeUploads/DeleteFile/${id}`);
  }
}
